<template>
    <component v-if="getComponentName" :is="getComponentName" />
</template>

<script>
import {
    ROUTES_REPORTS_STEP_TEST_GROUP,
    ROUTES_REPORTS_VO2_TEST_GROUP,
    ROUTES_REPORTS_2K_TEST_GROUP,
    ROUTES_REPORTS_6K_TEST_GROUP,
    ROUTES_SETTINGS_MY_CLUBS
} from '@/constants/routes';
import ClubsListMenu from '@/components/settings/my-clubs/ClubsListMenu.vue';

const DRV_REPORT_ROUTES = [
    ROUTES_REPORTS_STEP_TEST_GROUP,
    ROUTES_REPORTS_VO2_TEST_GROUP,
    ROUTES_REPORTS_2K_TEST_GROUP,
    ROUTES_REPORTS_6K_TEST_GROUP
];

export default {
    components: {
        ClubsListMenu,
        DrvReportsMenu: () => import('../reports/DrvReportsMenu.vue')
    },

    computed: {
        getComponentName() {
            if (this.$route.name === ROUTES_SETTINGS_MY_CLUBS) {
                return 'ClubsListMenu';
            }

            if (DRV_REPORT_ROUTES.includes(this.$route.name)) {
                return 'DrvReportsMenu';
            }
        }
    }
};
</script>
